import { useContext, useMemo } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const useSchedulingNotesColumn = () => {
  const { t } = useContext(ConfigContext);

  return useMemo(
    () => ({
      field: 'schedulingNotes',
      headerName: t('schedulingNotes'),
      width: 160,
      initialHide: true,
      sortable: false,
      cellClass: 'justify-start'
    }),
    [t]
  );
};

export default useSchedulingNotesColumn;
